import { SET_COMMISSION } from '../actionTypes'
// import moment from 'moment'

const initialState = []

export default (state=initialState,  payload) => {
    let commission = initialState

    if (payload.type === SET_COMMISSION) {
        commission = payload.commission || initialState
    } else {
        commission = state
    }

    return commission
}